export default __webpack_public_path__ + "static/media/alt.cbb4418c.svg";